module.exports = __webpack_public_path__ + "3b474551de23112aae98409c81cbe6c3.svg";